import React from "react";
import ClassBoardPicker from "../../../../../components/montessori-course-board/ClassBoardPicker";

/** Instructors only reach boards for classes they are assigned to. */
function InstructorCourseBoardMain() {
  return (
    <ClassBoardPicker
      source="instructor"
      basePath="/dashboard/instructor/menu/course-board/class"
    />
  );
}

export default InstructorCourseBoardMain;
